import camelcase from 'camelcase-es5';

const toPascalCase = (str = '') => camelcase(str, { pascalCase: true });

export default toPascalCase;
